import { DirectiveBinding } from 'vue/types/options';

// 滚动到底部
const scrollBottom = (el: HTMLElement, binding: DirectiveBinding) => {
  if (binding.value) {
    el.scrollTop = el.scrollHeight;
  }
};

// Modal 组件的 scrollBottom 指令
export const modalScrollBottom = {
  bind: scrollBottom,
  update: scrollBottom,
  componentUpdated: scrollBottom,
};
